import { normalizeGet } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var getClipboard = normalizeGet(function (args) {
  return ks.getClipboardData(args);
}, CONTAINER_NAME.KWAI);
export default getClipboard;